<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Users</h1>
          <div class="has-text-right">
            <b-button
              type="is-primary"
              class="has-margin-right-10"
              @click="exportContentRequirements()"
              >Export Content Requirements</b-button
            >
            <b-button
              type="is-primary"
              class="has-margin-right-10"
              @click="exportCart()"
              >Export Collections</b-button
            >
            <b-button
              type="is-primary"
              icon-left="plus"
              tag="router-link"
              :to="{ name: 'CreateUser' }"
              >Add</b-button
            >
          </div>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredUsers"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="company" label="Company">
                <div class="has-margin-top-5 has-margin-bottom-5">
                  <span class="has-text-weight-bold">{{
                    props.row.company
                  }}</span
                  ><br />
                  {{ props.row.first_name }} {{ props.row.last_name }}<br />
                  <a :href="`mailto:${props.row.email}`" target="_blank">{{
                    props.row.email
                  }}</a
                  ><br />
                  <a :href="`tel:${props.row.phone}`" target="_blank">{{
                    props.row.phone
                  }}</a>
                </div>
              </b-table-column>

              <b-table-column field="role" label="Roles">
                <div v-if="props.row.role && props.row.role.length > 0">
                  <b-tag
                    v-for="role in props.row.role.split(',')"
                    :key="role"
                    class="has-margin-right-5"
                    >{{ role }}</b-tag
                  >
                </div>
              </b-table-column>

              <b-table-column field="verified" label="Verified">
                {{ isVerified(props.row) ? 'Yes' : 'No' }}
                <a href="" @click.prevent="verify(props.row)">
                  <b-icon
                    v-if="!isVerified(props.row)"
                    icon="toggle-switch-off"
                  ></b-icon>
                </a>
              </b-table-column>

              <b-table-column label="">
                <b-dropdown aria-role="list">
                  <button slot="trigger" class="button is-primary">
                    <span>Actions</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'UpdateUser',
                        params: { id: props.row.id },
                      }"
                      >Edit</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="props.row.role.includes('buyer')"
                    aria-role="listitem"
                    :has-link="true"
                    ><router-link
                      :to="{
                        name: 'ManageCart',
                        params: { id: props.row.id },
                      }"
                      >View Collection</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="props.row.role.includes('buyer')"
                    aria-role="listitem"
                    :has-link="true"
                    ><router-link
                      :to="{
                        name: 'ManageRecommendations',
                        params: { id: props.row.id },
                      }"
                      >Manage Recommendation</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="changeAdmin(props.row)"
                    >{{
                      props.row.role.includes('admin')
                        ? 'Revoke Admin Access'
                        : 'Make Admin'
                    }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No users yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <!-- <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to delete this user?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="deleteTitle()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import UserApi from '@/api/user'
import axios from '@/axios'

export default {
  name: 'ManageUsers',
  components: {
    CardComponent,
  },
  metaInfo: {
    title: 'Manage Users',
  },
  computed: {
    ...mapGetters(['user']),
    filteredUsers() {
      if (this.search !== '' && this.users.length > 0) {
        let query = this.search.toLowerCase()
        return this.users.filter(
          (item) =>
            item.first_name.toLowerCase().includes(query) ||
            item.last_name.toLowerCase().includes(query) ||
            item.company.toLowerCase().includes(query) ||
            item.job_title.toLowerCase().includes(query) ||
            item.role.toLowerCase().includes(query)
        )
      } else {
        return this.users
      }
    },
  },
  created() {
    this.fetchUsers()
  },
  data() {
    return {
      loading: true,
      users: [],
      search: '',
      axios: axios,
      // showConfirmModal: false,
      // item: {}
    }
  },
  methods: {
    ...mapActions(['getUser']),
    isVerified(item) {
      return item && item.verified === 1
    },
    verify(item) {
      let updateObject = {
        id: item.id,
      }
      updateObject.verified = item.verified === 1 ? false : true
      UserApi.adminUpdate(updateObject)
        .then(() => {
          this.$buefy.toast.open({
            message: 'User verified status changed successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.fetchUsers()
        })
        .catch((err) => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing user verified status',
            position: 'is-top',
            type: 'is-danger',
          })
        })
    },
    changeAdmin(item) {
      let roles = item.role.split(',')
      if (roles.includes('admin')) {
        roles = roles.filter((role) => role !== 'admin')
      } else {
        roles.push('admin')
      }
      UserApi.adminUpdate({
        id: item.id,
        role: roles,
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Change role successfully',
            position: 'is-top',
            type: 'is-success',
          })
          this.fetchUsers()
        })
        .catch((err) => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing role',
            position: 'is-top',
            type: 'is-danger',
          })
        })
    },
    fetchUsers() {
      this.loading = true
      if (!this.$route.params.id) {
        UserApi.getAll().then((users) => {
          this.users = users
          this.loading = false
        })
      } else {
        UserApi.getAllByOrganisation(this.$route.params.id).then((users) => {
          this.users = users
          this.loading = false
        })
      }
    },
    exportContentRequirements() {
      window.location = `${this.axios.defaults.baseURL}/api/content-requirements/export`
    },
    exportCart() {
      window.location = `${this.axios.defaults.baseURL}/api/cart-items/export`
    },
  },
}
</script>
